const material = {
  // ==================== MATERIAL-SCHNELLERFASSUNG ====================
  'material.title': 'Material-Schnellerfassung',
  'material.subtitle': 'Materialstammdaten schnell erfassen und an SAP übermitteln',
  'material.inDevelopmentDesc': 'Die Material-Schnellerfassung bietet eine stark vereinfachte Maske mit reduzierten Pflichtfeldern, um neue Materialstämme schnell anzulegen.',

  // --- Tabs / Navigation ---
  'material.tabCapture': 'Erfassen',
  'material.tabList': 'Übersicht',
  'material.tabConfig': 'Feldkonfiguration',
  'material.newMaterial': 'Neues Material',

  // --- Org-Leiste / Kopf ---
  'material.matnr': 'Materialnummer',
  'material.matnrAuto': 'leer = interne Vergabe',
  'material.werks': 'Werk',
  'material.vkorg': 'VerkOrg',
  'material.vtweg': 'Vertriebsweg',
  'material.fromTemplate': 'Aus Vorlage',

  // --- Felder allgemein ---
  'material.selectPlaceholder': '– bitte wählen –',
  'material.yes': 'Ja',
  'material.descEn': 'Bezeichnung (EN)',
  'material.addEn': 'Englische Bezeichnung hinzufügen',
  'material.hideEn': 'Englische Bezeichnung ausblenden',
  'material.noFieldsConfigured': 'Es sind keine Felder aktiviert. Bitte in der Feldkonfiguration Felder aktivieren.',

  // --- Aktionen Erfassen ---
  'material.saveDraft': 'Als Entwurf speichern',
  'material.create': 'Anlegen',
  'material.update': 'Aktualisieren',
  'material.savedReady': 'Material angelegt.',
  'material.savedDraft': 'Entwurf gespeichert.',
  'material.missingRequired': 'Bitte alle Pflichtfelder (*) ausfüllen.',
  'material.saveError': 'Speichern fehlgeschlagen.',
  'material.fillProgress': '{filled} / {total} Felder ausgefüllt',
  'material.collapseAll': 'Alle einklappen',
  'material.expandAll': 'Alle ausklappen',
  'material.texts': 'Texte',
  'material.addText': 'Text hinzufügen',
  'material.textPlaceholder': 'Text eingeben…',
  'material.fillCol': 'Füllstand',

  // --- Dublettenprüfung ---
  'material.dupSetting': 'Dublettenprüfung beim Anlegen',
  'material.dupSettingHint': 'Optional: prüft vor dem Anlegen, ob ein ähnliches Material existiert (gegen Doppelanlage).',
  'material.dupTitle': 'Mögliche Dublette gefunden',
  'material.dupSubtitle': 'Es existieren ähnliche Materialien. Bitte prüfen, ob es sich um eine Doppelanlage handelt.',
  'material.dupSourceMaterial': 'Erfassung',
  'material.dupSourceCatalog': 'Katalog',
  'material.dupSourceSap': 'SAP-Materialstamm',
  'material.dupReason_ean': 'gleiche EAN',
  'material.dupReason_bismt': 'gleiche Materialnummer',
  'material.dupReason_desc': 'ähnliche Bezeichnung',
  'material.dupReason_matkl': 'gleiche Warengruppe',
  'material.dupMatch': 'Übereinstimmung',
  'material.dupCancel': 'Abbrechen',
  'material.dupProceed': 'Trotzdem anlegen',

  // --- Feldkonfig-Presets ---
  'material.presets': 'Presets',
  'material.presetChoose': '– Preset wählen –',
  'material.presetLoad': 'Laden',
  'material.presetSaveAs': 'Als Preset speichern',
  'material.presetReset': 'Auf Standard zurücksetzen',
  'material.presetNamePrompt': 'Name für die Konfiguration:',
  'material.presetSaved': 'Preset gespeichert.',
  'material.presetSaveError': 'Preset konnte nicht gespeichert werden.',
  'material.presetApplied': 'Preset „{name}" angewendet (noch nicht gespeichert).',
  'material.presetConfirmDelete': 'Preset „{name}" wirklich löschen?',
  'material.presetDeleted': 'Preset gelöscht.',
  'material.presetDeleteError': 'Preset konnte nicht gelöscht werden.',
  'material.settingsSaved': 'Einstellung gespeichert.',

  // --- PDF-Anhänge ---
  'material.attachments': 'Anhänge (PDF)',
  'material.attAdd': 'PDF hinzufügen',
  'material.attDropHint': 'PDFs hierher ziehen oder „PDF hinzufügen"',
  'material.attDropHintNew': 'PDFs hierher ziehen — werden nach dem Speichern hochgeladen',
  'material.attDropNow': 'Loslassen zum Hochladen',
  'material.attPending': 'wird beim Speichern hochgeladen',
  'material.attSaveFirst': 'Material zuerst speichern, dann können PDFs angehängt werden.',
  'material.attEmpty': 'Noch keine Anhänge.',
  'material.attOnlyPdf': 'Nur PDF-Dateien erlaubt.',
  'material.attUploaded': 'PDF angehängt.',
  'material.attUploadError': 'Upload fehlgeschlagen.',
  'material.attLoadError': 'Anhänge konnten nicht geladen werden.',
  'material.attDownload': 'Öffnen',
  'material.attConfirmDelete': 'Diesen Anhang wirklich löschen?',
  'material.attDeleted': 'Anhang gelöscht.',
  'material.attDeleteError': 'Löschen fehlgeschlagen.',

  // --- Feldkonfiguration (Admin) ---
  'material.configTitle': 'Felder verwalten',
  'material.activeFields': '{n} von {total} Feldern aktiv',
  'material.configSave': 'Konfiguration speichern',
  'material.configSaved': 'Feldkonfiguration gespeichert.',
  'material.configSaveError': 'Konfiguration konnte nicht gespeichert werden.',
  'material.configLoadError': 'Feldkonfiguration konnte nicht geladen werden.',
  'material.coreField': 'Pflichtkern',
  'material.toggleActive': 'Aktiv',
  'material.toggleRequired': 'Pflicht',
  'material.configSearch': 'Feld suchen (Bezeichnung, SAP-Feld)…',
  'material.allActive': 'Alle aktiv',
  'material.allRequired': 'Alle Pflicht',
  'material.allSap': 'Alle SAP',
  'material.allOff': 'Alle ab',
  'material.toggleSap': 'Aus SAP',
  // --- Material aus SAP laden ---
  'material.sapLoad': 'Aus SAP laden',
  'material.sapLoadTitle': 'Material aus SAP laden',
  'material.sapLoadSubtitle': 'SAP-Materialstamm durchsuchen und als Vorlage übernehmen (Stub: Spiegel; echter SAP-Read folgt).',
  'material.sapSearchPlaceholder': 'Suche im SAP-Materialstamm (Bezeichnung, Nummer, EAN)…',
  'material.sapNoResults': 'Keine SAP-Materialien gefunden.',
  'material.sapNoVisibleFields': 'Keine Felder als „aus SAP sichtbar" konfiguriert.',
  'material.sapUseAsTemplate': 'Als Vorlage',
  'material.sapSearchError': 'SAP-Suche fehlgeschlagen.',
  'material.sapLoadError': 'SAP-Material konnte nicht geladen werden.',

  // --- Übersicht ---
  'material.searchPlaceholder': 'Suche (Bezeichnung, Nummer, Warengruppe)…',
  'material.allStatus': 'Alle Status',
  'material.status_draft': 'Entwurf',
  'material.status_ready': 'Bereit',
  'material.status_transferred': 'Übertragen',
  'material.description': 'Bezeichnung',
  'material.mtart': 'Materialart',
  'material.matkl': 'Warengruppe',
  'material.statusCol': 'Status',
  'material.actions': 'Aktionen',
  'material.edit': 'Bearbeiten',
  'material.useAsTemplate': 'Als Vorlage nutzen',
  'material.transfer': 'An SAP übertragen',
  'material.mirror': 'In Katalog spiegeln',
  // --- SAP-Transfer ---
  'material.trfTitle': 'An SAP übertragen',
  'material.trfStubNote': 'Noch kein realer SAP-Call: das BAPI-Payload wird erzeugt und protokolliert, der Status wird auf „Übertragen" gesetzt. Der echte BAPI_MATERIAL_SAVEDATA-Aufruf wird angebunden, sobald die SAP-Verbindung steht.',
  'material.trfConfirm': 'An SAP übertragen (Stub)',
  'material.trfUnmapped': 'Noch nicht gemappt (Abstimmung nötig)',
  'material.trfDone': 'An SAP übertragen.',
  'material.trfError': 'Übertragung fehlgeschlagen.',
  'material.trfPreviewError': 'Vorschau konnte nicht geladen werden.',
  'material.delete': 'Löschen',
  'material.emptyList': 'Noch keine Materialien angelegt.',
  'material.listError': 'Materialliste konnte nicht geladen werden.',
  'material.loadError': 'Material konnte nicht geladen werden.',
  'material.mirrorSuccess': 'Material in den Katalog gespiegelt.',
  'material.mirrorError': 'Spiegeln fehlgeschlagen.',
  'material.confirmDelete': 'Dieses Material wirklich löschen?',
  'material.deleteSuccess': 'Material gelöscht.',
  'material.deleteError': 'Löschen fehlgeschlagen.',
};

export default material;
